




























import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// The base for every input component
import InputBase from './Base.vue';

@Component
export default class InputSelect extends InputBase<string> {

    @Prop({ type: Object, required: true })
    private options!: { [guid: string]: string; };

}
